require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./testing-interaction-testing.json") })
        }
      }, "path---testing-interaction-testing");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---testing-interaction-testing!./.cache/json/testing-interaction-testing.json
// module id = 429
// module chunks = 231608221292675